// extracted by mini-css-extract-plugin
export default {"wrapper":"OtpInput_wrapper__YamjR","input":"OtpInput_input__AFP-z"};